<template>
  <div
    class="gamecard-wrap"
    @mousemove="handleMouseMove"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    ref="gamecard"
  >
    <div class="gamecard" :style="gamecardStyle">
      <div class="gamecard-bg" :style="[gamecardBgTransform, gamecardBgImage]"></div>
      <div class="gamecard-info">
        <slot name="header"></slot>
        <slot name="content"></slot>
        <slot name="btn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.width = this.$refs.gamecard.offsetWidth;
    this.height = this.$refs.gamecard.offsetHeight;
  },

  props: ["dataImage"],

  data: () => ({
    width: 0,
    height: 0,
    mouseX: 0,
    mouseY: 0,
    mouseLeaveDelay: null
  }),

  computed: {
    mousePX() {
      return this.mouseX / this.width;
    },
    mousePY() {
      return this.mouseY / this.height;
    },
    gamecardStyle() {
      const rX = this.mousePX * 30;
      const rY = this.mousePY * -30;

      return {
        transform: `rotateY(${rX}deg) rotateX(${rY}deg)`
      };
    },
    gamecardBgTransform() {
      const tX = this.mousePX * -40;
      const tY = this.mousePY * -40;
      return {
        transform: `translateX(${tX}px) translateY(${tY}px)`
      };
    },
    gamecardBgImage() {
      return {
        backgroundImage: `url(${this.dataImage})`
      };
    }
  },

  methods: {
    handleMouseMove(e) {
      this.mouseX = e.pageX - this.$refs.gamecard.offsetLeft - this.width / 2;
      // if (this.$refs.gamecard.offsetTop > 4000) {
      // } else if (this.$refs.gamecard.offsetTop > 3800) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 510;
      // } else if (this.$refs.gamecard.offsetTop > 3500) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 520;
      // } else if (this.$refs.gamecard.offsetTop > 3100) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 530;
      // } else if (this.$refs.gamecard.offsetTop > 2600) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 530;
      // } else if (this.$refs.gamecard.offsetTop > 2500) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 690;
      // } else if (this.$refs.gamecard.offsetTop > 2400) {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 700;
      // } else {
      //   this.mouseY = (e.pageY - this.$refs.gamecard.offsetTop - this.height / 2) - 750;
      // }
    },
    handleMouseEnter() {
      clearTimeout(this.mouseLeaveDelay);
    },
    handleMouseLeave() {
      this.mouseLeaveDelay = setTimeout(() => {
        this.mouseX = 0;
        this.mouseY = 0;
      }, 1000);
    }
  }
};
</script>

<style>
.gamecard-wrap {
  margin: 10px;
  transform: perspective(800px);
  transform-style: preserve-3d;
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.gamecard-wrap:hover .gamecard-info {
  transform: translateY(0);
}
.gamecard-wrap:hover .gamecard-info p {
  opacity: 1;
}
.gamecard-wrap:hover .gamecard-info,
.gamecard-wrap:hover .gamecard-info p {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}
.gamecard-wrap:hover .gamecard-info:after {
  transition: 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 1;
  transform: translateY(0);
}
.gamecard-wrap:hover .gamecard-bg {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 5s cubic-bezier(0.23, 1, 0.32, 1);
  opacity: 0.8;
}
.gamecard-wrap:hover .gamecard {
  transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 2s cubic-bezier(0.23, 1, 0.32, 1);
  box-shadow: rgba(255, 255, 255, 0.2) 0 0 40px 5px,
    rgba(255, 255, 255, 1) 0 0 0 1px, rgba(0, 0, 0, 0.66) 0 10px 60px 0,
    inset #333 0 0 0 5px, inset white 0 0 0 6px;
}

.gamecard {
  position: relative;
  flex: 0 0 240px;
  width: 240px;
  height: 320px;
  background-color: rgb(122, 122, 122);
  overflow: hidden;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.4) 0 7px 60px 0, inset #333 0 0 0 5px,
    inset rgba(255, 255, 255, 0.5) 0 0 0 6px;
  /* box-shadow: rgba(0, 0, 0, 0.4) 0 7px 60px 0, inset #333 0 0 0 0px, inset rgba(255, 255, 255, 0) 0 0 0 6px; */
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.gamecard-bg {
  opacity: 0.7;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transition: 1s cubic-bezier(0.445, 0.05, 0.55, 0.95),
    opacity 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
  pointer-events: none;
}
.gamecard-info {
  padding: 20px;
  position: absolute;
  bottom: 0;
  color: #fff;
  transform: translateY(40%);
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.gamecard-info p {
  opacity: 0;
  text-shadow: rgba(0, 0, 0, 1) 0 2px 3px;
  transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
}
.gamecard-info * {
  position: relative;
  z-index: 1;
}
.gamecard-info:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  background-blend-mode: overlay;
  opacity: 0;
  transform: translateY(100%);
  transition: 5s 1s cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.gamecard-info h1 {
  font-family: "Playfair Display";
  font-size: 36px;
  font-weight: 700;
  text-shadow: rgba(0, 0, 0, 0.5) 0 10px 10px;
}
</style>

